module.exports = __webpack_public_path__ + "static/img/13.81717e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/13.png
// module id = zOEQ
// module chunks = 0